export enum MutationTypes {
    SET_SUBSCRIPTION_DATA_IS_LOADING = "setSubscriptionDataIsLoading",
    SET_SUBSCRIPTION_DATA = "setSubscriptionData",
    SET_SUBSCRIPTION_PLANS_LIST = "setSubscriptionPlansList"
}